import BackupTableIcon from "@mui/icons-material/BackupTable";
import CalculateIcon from "@mui/icons-material/Calculate";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	IconButton,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import { useContext, useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButton from "../../../../components/CustomButton/CustomButton.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalCadastro from "../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfigTabela from "../../../../components/ModalConfigTabela/ModalConfigTabela.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalEmbarque from "../../../../components/ModalEmbarque/ModalEmbarque.tsx";
import ModalHistoricoEdicao from "../../../../components/ModalHistoricoEdicao/ModalHistoricoEdicao.tsx";
import ModalHistoricoStatus from "../../../../components/ModalHistoricoStatus/ModalHistoricoStatus.tsx";
import ModalLancarCTE from "../../../../components/ModalLancarCTE/ModalLancarCTE.tsx";
import ModalLancarEmbalagem from "../../../../components/ModalLancarEmbalagem/ModalLancarEmbalagem.tsx";
import ModalLancarMeioPagamento from "../../../../components/ModalLancarMeioPagamento/ModalLancarMeioPagamento.tsx";
import ModalLancarMercadoria from "../../../../components/ModalLancarMercadoria/ModalLancarMercadoria.tsx";
import ModalLancarStatus from "../../../../components/ModalLancarStatus/ModalLancarStatus.tsx";
import ModalLancarVeiculo from "../../../../components/ModalLancarVeiculo/ModalLancarVeiculo.tsx";
import ModalLegenda from "../../../../components/ModalLegenda/ModalLegenda.tsx";
import ModalListaErros from "../../../../components/ModalListaErros/ModalListaErros.tsx";
import ModalOnTime from "../../../../components/ModalOnTime/ModalOnTime.tsx";
import ModalProposta from "../../../../components/ModalProposta/ModalProposta.tsx";
import ModalStatusSMP from "../../../../components/ModalStatusSMP/ModalStatusSMP.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import TabelaLow from "../../../../components/TabelaLow/TabelaLow.js";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastAviso from "../../../../components/Toast/ToastAviso/ToastAviso.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import FiltrosRedux from "../../../../contexts/Filtros";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import NomeTabelaRedux from "../../../../contexts/NomeTabela";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import Icon from "../../../../core/components/Icon.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import iconeConfig from "../../../../images/iconeConfig.png";
import iconeDownload from "../../../../images/iconeDownload.png";
import iconeInfo from "../../../../images/iconeInfo2.png";
import {
	buscaSMP,
	insereSMP,
} from "../../../../services/ModuloGerenciador/ApiSul.js";
import {
	cancelarEmbarque,
	comprovanteEntregue,
	definirMeiosPagamentos,
	deleteEmbarquePorId,
	getEmbarquePorId,
	getHistoricoEmbarque,
	getHistoricoFreteFiscal,
	getHistoricoPedido,
	getHistoricoStatus,
	lancarCheckin,
	lancarCte,
	lancarEmbalagem,
	lancarMercadoria,
	lancarStatus,
	lancarVeiculo,
} from "../../../../services/ModuloGerenciador/Embarque";
import {
	getEmbarqueDependencias,
	getEmbarqueGeral,
	getGrupoCargaDependencias,
} from "../../../../services/ModuloGerenciador/Geral.ts";
import { getMeioPagamento } from "../../../../services/ModuloGerenciador/MeioPagamento.js";
import {
	getMotivoOnTime,
	vincularMotivoPorId,
} from "../../../../services/ModuloGerenciador/MotivoOnTime.js";
import { enviarProposta } from "../../../../services/ModuloGerenciador/Proposta";
import {
	getEmbarqueDiariaSearch,
	getEmbarqueMesoRegiaSearch,
} from "../../../../services/ModuloGerenciador/Search";
import {
	deleteTemplateEmbarquePorId,
	getTemplateEmbarque,
	getTemplateEmbarquePorId,
} from "../../../../services/ModuloGerenciador/TemplateEmbarque";
import { getTipoContatoPorProprietarioId } from "../../../../services/ModuloGerenciador/TipoContato.js";
import CadastroViagem from "../StepperV2/CadastroViagem.js";
import "./EmbarqueMesoRegiao.css";

const colunasStatusEmbarque = [
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Data",
		field: "data",
	},
	{
		nomeColuna: "Usuário",
		field: "usuario",
	},
];

const colunasPedidoEmbarque = [
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "Data",
		field: "data",
	},
	{
		nomeColuna: "Usuário",
		field: "usuario",
	},
];

const colunasFreteFiscalEmbarque = [
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
	},
	{
		nomeColuna: "Data",
		field: "data",
	},
	{
		nomeColuna: "Usuário",
		field: "usuario",
	},
];

const itensFiltro = [
	{
		nomeColuna: "Tipo Carroceria",
		field: "tipoCarroceria",
	},
	{
		nomeColuna: "Descrição",
		field: "descricao",
	},
	{
		nomeColuna: "Empresa",
		field: "empresa",
	},
	{
		nomeColuna: "Filial",
		field: "filial",
	},
	{
		nomeColuna: "Unidade de Embarque",
		field: "unidEmbarque",
	},
	{
		nomeColuna: "Pedido",
		field: "pedido",
	},
	{
		nomeColuna: "CTE",
		field: "cte",
	},
	{
		nomeColuna: "Previsão Viagem",
		field: "previsaoEmbarque",
	},
	{
		nomeColuna: "Data Viagem",
		field: "dataEmbarque",
	},
	{
		nomeColuna: "Previsão Entrega",
		field: "previsaoEntrega",
	},
	{
		nomeColuna: "Data Entrega",
		field: "dataEntrega",
	},
	{
		nomeColuna: "Data Hora Chegada Viagem",
		field: "dataHoraChegadaEmbarque",
	},
	{
		nomeColuna: "Data Hora Chegada Entrega",
		field: "dataHoraChegadaEntrega",
	},
	{
		nomeColuna: "Data Hora Entregue",
		field: "dataHoraEntregue",
	},
	{
		nomeColuna: "Data Hora Embarcado",
		field: "dataHoraEmbarcado",
	},
	{
		nomeColuna: "Aceite",
		field: "aceite",
	},
	{
		nomeColuna: "Status",
		field: "status",
	},
	{
		nomeColuna: "Placa Cavalo",
		field: "placaCavalo",
	},
	{
		nomeColuna: "Placa Carreta",
		field: "placaCarreta",
	},
	{
		nomeColuna: "Placa Segunda Carreta",
		field: "placaCarreta2",
	},
	{
		nomeColuna: "Proprietario",
		field: "proprietario",
	},
	{
		nomeColuna: "Motorista",
		field: "veiculoMotorista",
	},
	{
		nomeColuna: "ICMS",
		field: "icms",
	},
	{
		nomeColuna: "Frete Motorista",
		field: "freteMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Frete Fiscal",
		field: "freteFiscal",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Empresa",
		field: "adicionalEmpresa",
		tipo: "number",
	},
	{
		nomeColuna: "Adicional Motorista",
		field: "adicionalMotorista",
		tipo: "number",
	},
	{
		nomeColuna: "Pedagio",
		field: "pedagio",
		tipo: "number",
	},
	{
		nomeColuna: "Classificação",
		field: "classificacao",
		tipo: "number",
	},
	{
		nomeColuna: "Margem",
		field: "margem",
	},
	{
		nomeColuna: "Adiantamento",
		field: "adiantamento",
		tipo: "number",
	},
	{
		nomeColuna: "Saldo",
		field: "saldo",
		tipo: "number",
	},
	{
		nomeColuna: "Meio Pagamento",
		field: "meioPagamento",
	},
	{
		nomeColuna: "Meio Pagamento Dois",
		field: "meioPagamento2",
	},
	{
		nomeColuna: "Km",
		field: "km",
		tipo: "number",
	},
	{
		nomeColuna: "Cliente",
		field: "cliente",
	},
	{
		nomeColuna: "Embarcador",
		field: "embarcador",
	},
	{
		nomeColuna: "Destinatario",
		field: "destinatario",
	},
	{
		nomeColuna: "LOAD",
		field: "load",
	},
	{
		nomeColuna: "Mercadoria",
		field: "mercadoria",
	},
	{
		nomeColuna: "Peso",
		field: "peso",
		tipo: "number",
	},
	{
		nomeColuna: "Embalagem",
		field: "embalagem",
	},
	{
		nomeColuna: "Observação",
		field: "observacao",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
	{
		nomeColuna: "Cancelado",
		field: "cancelado",
	},
	{
		nomeColuna: "Motivo",
		field: "motivo",
	},
	{
		nomeColuna: "Usuário Responsável",
		field: "usuarioResponsavel",
	},
	{
		nomeColuna: "Elegível BRF",
		field: "elegivelBrf",
	},
];

const formatarData = (dataString) => {
	const data = new Date(dataString);
	const dia = data.getDate().toString().padStart(2, "0");
	const mes = (data.getMonth() + 1).toString().padStart(2, "0");
	const ano = data.getFullYear();
	return `${dia}-${mes}-${ano}`;
};

function EmbarqueMesoRegiao() {
	const navigate = useNavigate();

	const voltar = () => {
		navigate("/mapa-meso");
	};

	const acoesData = [
		{
			titulo: "Buscar Histórico Status",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoStatus();
			},
		},
		{
			titulo: "Buscar Histórico Pedido",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoPedido();
			},
		},
		{
			titulo: "Buscar Histórico Frete Fiscal",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				abrirModalHistoricoFreteFiscal();
			},
		},
		{
			titulo: "Buscar Status SMP",
			onClick: () => {
				setEmbarqueIdSMP(tabelaRedux.colunaSelecionada);
			},
		},
		{
			titulo: "Inserir SMP",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenConfirmar(true);
			},
		},
		{
			titulo: "Definir Meios de Pagamento",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMeioPagamento(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Informar Comprovante",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				definirComprovante();
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Informar Checkin Concluído",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				definirCheck();
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Lançar Status",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenStatus(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Lançar Mercadoria",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMercadoria(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Lançar Embalagem",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenEmbalagem(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Lançar Veículo",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenVeiculo(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Lançar CTE",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenCTE(true);
				setOpcoesOpen(false);
			},
		},
		{
			titulo: "Motivo Viagem",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				if (tabelaRedux?.row?.necessitaMotivoEmbarque === true) {
					setOpcoesOpen(false);
					setIsEmbarque(true);
					setIsEntrega(false);
					setOpenMotivoOnTime(true);
				} else {
					setTextoErro("Carga não necessita de motivo");
					setOpenToastErro(true);
				}
			},
		},
		{
			titulo: "Motivo Entrega",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				if (tabelaRedux?.row?.necessitaMotivoEntrega === true) {
					setOpcoesOpen(false);
					setIsEmbarque(false);
					setIsEntrega(true);
					setOpenMotivoOnTime(true);
				} else {
					setTextoErro("Carga não necessita de motivo");
					setOpenToastErro(true);
				}
			},
		},
		{
			titulo: "Cancelar Carga",
			onClick: () => {
				setEmbarqueId(tabelaRedux.colunaSelecionada);
				setOpenMotivoCancelado(true);
				setOpcoesOpen(false);
			},
		},
	];

	const [openCTE, setOpenCTE] = useState(false);

	const handleCloseCTE = (value) => {
		setCTE(null);
		setOpenCTE(false);
	};

	const [openStatus, setOpenStatus] = useState(false);

	const handleCloseStatus = (value) => {
		setStatus(null);
		setOpenStatus(false);
	};

	const [openEmbalagem, setOpenEmbalagem] = useState(false);

	const handleCloseEmbalagem = (value) => {
		setEmbalagem(null);
		setOpenEmbalagem(false);
	};

	const [openMercadoria, setOpenMercadoria] = useState(false);

	const handleCloseMercadoria = (value) => {
		setMercadoria(null);
		setOpenMercadoria(false);
	};

	const [openVeiculo, setOpenVeiculo] = useState(false);

	const handleCloseVeiculo = (value) => {
		setVeiculo(null);
		setOpenVeiculo(false);
	};

	const [openMeioPagamento, setOpenMeioPagamento] = useState(false);

	const handleCloseMeioPagamento = (value) => {
		setMeioPagamento1(null);
		setMeioPagamento2(null);
		setOpenMeioPagamento(false);
	};

	const [openMotivoOnTime, setOpenMotivoOnTime] = useState(false);

	const handleCloseMotivoOnTime = (value) => {
		setOpenMotivoOnTime(false);
	};

	const [openMotivoCancelado, setOpenMotivoCancelado] = useState(false);

	const handleCloseMotivoCancelado = (value) => {
		setOpenMotivoCancelado(false);
	};

	const [listaMotivos, setListaMotivos] = useState([]);

	const [listaMotivosOnTime, setListaMotivosOnTime] = useState([]);

	const [motivoId, setMotivoId] = useState();

	const [motivoId2, setMotivoId2] = useState();

	const [embarqueId, setEmbarqueId] = useState();

	const [embarqueIdSMP, setEmbarqueIdSMP] = useState();

	useEffect(() => {
		if (embarqueIdSMP !== undefined) {
			buscarSMP();
		}
	}, [embarqueIdSMP]);

	const [cte, setCTE] = useState();

	const [status, setStatus] = useState();

	const [embalagem, setEmbalagem] = useState();

	const [mercadoria, setMercadoria] = useState();

	const [veiculo, setVeiculo] = useState();

	const [meioPagamento1, setMeioPagamento1] = useState();

	const [meioPagamento2, setMeioPagamento2] = useState();

	const [motorista, setMotorista] = useState();

	const [nomeMotivo, setNomeMotivo] = useState();

	const [isEmbarque, setIsEmbarque] = useState(false);

	const [isEntrega, setIsEntrega] = useState(false);

	const buscarMeioPagamento = async () => {
		setLoadingSelectMeioPagamento(true);
		await getMeioPagamento(profile?.token)
			.then((result) => {
				setListaMeioPagamento(result.data);
				setLoadingSelectMeioPagamento(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarMotivo = async () => {
		setLoadingSelectMotivo(true);
		await getMotivoOnTime(profile?.token)
			.then((result) => {
				setListaMotivosOnTime(result.data);
				setLoadingSelectMotivo(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const { hasRegra, profile, contextoEmbarque, coresEmpresa } = useProfile();

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [openToastAviso, setOpenToastAviso] = useState(false);

	const [textoAviso, setTextoAviso] = useState("");

	const handleCloseToastAviso = (value) => {
		setOpenToastAviso(false);
	};

	const [dadosTabela, setDadosTabela] = useState([]);

	const [mesoRegiao, setMesoRegiao] = useState("");

	const [ufMesoRegiao, setUfMesoRegiao] = useState("");

	const [canceladoRegiao, setCanceladoRegiao] = useState(false);

	const [somatorioFreteFiscal, setSomatorioFreteFiscal] = useState("");

	const [somatorioFreteMotorista, setSomatorioFreteMotorista] = useState("");

	const [somatorioIcms, setSomatorioIcms] = useState("");

	const [somatorioKm, setSomatorioKm] = useState("");

	const [cardSomatorio, setCardSomatorio] = useState(false);

	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);

	const [dadosTabelaCopiaFiltro, setDadosTabelaCopiaFiltro] = useState([]);

	const [dadosAgrupado, setDadosAgrupado] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando2, setEditando2] = useState(false);

	const [verificaMotivo, setVerificaMotivo] = useState(true);

	const [verificaMotorista2, setVerificaMorista2] = useState(true);

	const [numeroEmbarque, setNumeroEmbarques] = useState(0);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [pedido, setPedido] = useState([]);

	const [listaUnidades, setListaUnidades] = useState([]);

	const [listaEmpresas, setListaEmpresas] = useState([]);

	const [listaFilial, setListaFilial] = useState([]);

	const [listaVeiculos, setListaVeiculos] = useState([]);

	const [listaEmbalagens, setListaEmbalagens] = useState([]);

	const [listaStatus, setListaStatus] = useState([]);

	const [listaMeioPagamento, setListaMeioPagamento] = useState([]);

	const [listaMotivo, setListaMotivo] = useState([]);

	const [listaMercadoria, setListaMercadoria] = useState([]);

	const [valoresHistorico, setValoresHistorico] = useState([]);

	const [valoresHistoricoStatus, setValoresHistoricoStatus] = useState([]);

	const [valoresHistoricoPedido, setValoresHistoricoPedido] = useState([]);

	const [valoresHistoricoFreteFiscal, setValoresHistoricoFreteFiscal] =
		useState([]);

	const [openHistoricoEdicao, setOpenHistoricoEdicao] = useState(false);

	const [openCadastroPedido, setOpenCadastroPedido] = useState(false);

	const [loadingSelectPedido, setLoadingSelectPedido] = useState(false);

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	useEffect(() => {
		if (valuesPesquisa.contexto) {
			buscarSearch();
		} else {
			setLoading(false);
		}
	}, [valuesPesquisa.contexto]);

	const intervalRef = useRef(null);

	const [index, setIndex] = useState(0);

	useEffect(() => {
		setLoading(true);
		if (dadosAgrupado.length > 0) {
			setDadosTabela(dadosAgrupado[index].embarques);
			setMesoRegiao(dadosAgrupado[index].nomeMesorregiao);
			setUfMesoRegiao(dadosAgrupado[index].uf);
			setSomatorioFreteFiscal(dadosAgrupado[index].cards?.freteFiscalString);
			setSomatorioFreteMotorista(
				dadosAgrupado[index].cards?.freteMotoristaString
			);
			setSomatorioIcms(dadosAgrupado[index].cards?.icmsString);
			setSomatorioKm(dadosAgrupado[index].cards?.kmString);
			const listaEmbarques = [];
			dadosAgrupado[index].embarques.forEach((embarque) => {
				listaEmbarques.push(embarque);
			});
			setNumeroEmbarques(listaEmbarques.length);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	}, [index]);

	const setPrev = () => {
		setIndex((prevIndex) => (prevIndex - 1) % dadosAgrupado.length);
	};

	const setProx = () => {
		setIndex((prevIndex) => (prevIndex + 1) % dadosAgrupado.length);
	};

	useEffect(() => {
		if (dadosAgrupado.length > 0) {
			setProx();
			intervalRef.current = setInterval(setProx, 30000);
			return () => {
				clearInterval(intervalRef.current);
			};
		}
	}, [dadosAgrupado]);

	const [selecioneOpen, setSelecioneOpen] = useState(false);

	const [opcoesOpen, setOpcoesOpen] = useState(false);

	const [viewTable, setViewTable] = useState(true);

	useEffect(() => {
		const storedViewTable = localStorage.getItem("viewTable");
		if (storedViewTable === null) {
			setViewTable(true);
		} else {
			setViewTable(storedViewTable === "true");
		}
	}, []);

	const onClickOpenProjecao = () => {
		const newViewTable = !viewTable;
		localStorage.setItem("viewTable", newViewTable);
		setViewTable(newViewTable);
	};

	useEffect(() => {
		const storedCardSomatorio = localStorage.getItem("cardSomatorio");
		if (storedCardSomatorio === null) {
			setCardSomatorio(false);
		} else {
			setCardSomatorio(storedCardSomatorio === "true");
		}
	}, []);

	const onClickOpenSomatorio = () => {
		const newCardSomatorio = !cardSomatorio;
		localStorage.setItem("cardSomatorio", newCardSomatorio);
		setCardSomatorio(newCardSomatorio);
	};

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopiaFiltro);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const handleSearch = (ordenarPor) => {
		if (estadia) {
			buscarSearchDiaria(ordenarPor);
		} else {
			buscarSearch(ordenarPor);
		}
	};

	const buscarOrdenacao = (ordenarPor) => {
		handleSearch(ordenarPor);
	};

	const buscarSearch = async (ordenarPor) => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}

		if (
			valuesPesquisa.embarqueInicio &&
			valuesPesquisa.embarqueFinal &&
			profile
		) {
			await getEmbarqueMesoRegiaSearch({
				token: profile?.token,
				pesquisa: pesquisaFormatada,
				contexto: "todos",
				dataInicio: valuesPesquisa.embarqueInicio,
				dataFim: valuesPesquisa.embarqueFinal,
				ordenarPor: ordenarPor,
				cancelado: canceladoRegiao,
			})
				.then((result) => {
					const agrupado = result.data.agrupado;
					const maxIndex = agrupado.length;
					setDadosTabela(result.data.agrupado[0].embarques);
					setMesoRegiao(result.data.agrupado[0].nomeMesorregiao);
					setUfMesoRegiao(result.data.agrupado[0].uf);
					setSomatorioFreteFiscal(
						result.data?.agrupado[0].cards?.freteFiscalString
					);
					setSomatorioFreteMotorista(
						result.data?.agrupado[0].cards?.freteMotoristaString
					);
					setSomatorioIcms(result.data?.agrupado[0].cards?.icmsString);
					setSomatorioKm(result.data?.agrupado[0].cards?.kmString);
					const listaEmbarques = [];
					result.data.agrupado[0].embarques.forEach((embarque) => {
						listaEmbarques.push(embarque);
					});
					setNumeroEmbarques(listaEmbarques.length);
					setDadosAgrupado(result.data.agrupado);
					setIndex((prevIndex) => (prevIndex + 1) % maxIndex);
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
						setLoading(false);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
						setOpenToastErro(true);
						setLoading(false);
					}
					setLoading(false);
				});
		}
	};

	const buscarSearchDiaria = async (ordenarPor) => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getEmbarqueDiariaSearch(
			profile?.token,
			pesquisaFormatada,
			contextoEmbarque,
			valuesPesquisa.embarqueInicio,
			valuesPesquisa.embarqueFinal,
			ordenarPor
		)
			.then((result) => {
				setDadosTabela(result.data);
				const listaEmbarques = [];
				result.data.forEach((embarque) => {
					if (embarque.cancelado === false) {
						listaEmbarques.push(embarque);
					}
				});
				setNumeroEmbarques(listaEmbarques.length);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const [dataPesquisa, setDataPesquisa] = useState();

	const [mesAtual, setMesAtual] = useState();

	const [anoAtual, setAnoAtual] = useState();

	const [periodoCompleto, setCompleto] = useState();

	const [estadia, setEstadia] = useState();

	const mesAnterior = () => {
		setOpcoesOpen(false);
		setCompleto(false);
		const date = new Date(dataPesquisa);
		date.setMonth(date.getMonth() - 1);
		const mesPorExtenso = date.toLocaleString("pt-BR", { month: "long" });
		setMesAtual(mesPorExtenso);
		var ddFinal = String(date.getDate()).padStart(2, "0");
		var mmFinal = String(date.getMonth() + 1).padStart(2, "0");
		var yyyyFinal = date.getFullYear();
		setAnoAtual(yyyyFinal);
		var dateFinalFormated = `${yyyyFinal}-${mmFinal}-${ddFinal}`;
		setDataPesquisa(dateFinalFormated);
	};

	const mesSeguinte = () => {
		setCompleto(false);
		setOpcoesOpen(false);
		const date = new Date(dataPesquisa);
		date.setMonth(date.getMonth() + 1);
		const mesPorExtenso = date.toLocaleString("pt-BR", { month: "long" });
		setMesAtual(mesPorExtenso);
		var ddFinal = String(date.getDate()).padStart(2, "0");
		var mmFinal = String(date.getMonth() + 1).padStart(2, "0");
		var yyyyFinal = date.getFullYear();
		setAnoAtual(yyyyFinal);
		var dateFinalFormated = `${yyyyFinal}-${mmFinal}-${ddFinal}`;
		setDataPesquisa(dateFinalFormated);
	};

	useEffect(() => {
		if (dataPesquisa !== undefined) {
			buscarDependenciasData();
		}
	}, [dataPesquisa]);

	const setPeriodoCompleto = (boolean) => {
		if (boolean === true) {
			buscarDependencias();
		} else {
			buscarDependenciasData();
		}
	};

	const setFiltroEstadia = (boolean) => {
		if (boolean === true) {
			buscarSearchDiaria();
		} else {
			buscarDependenciasData();
		}
	};

	const handleCloseCadastroPedido = (value) => {
		setLoading(true);
		setLoadingSelectPedido(true);
		buscarDependenciasSemLoading();
		setOpenCadastroPedido(false);
	};

	const [openCadastroUnidadeEmbarque, setOpenCadastroUnidadeEmbarque] =
		useState(false);

	const [loadingSelectUnidadeEmbarque, setLoadingSelectUnidadeEmbarque] =
		useState(false);

	const handleCloseCadastroUnidadeEmbarque = (value) => {
		setLoadingSelectUnidadeEmbarque(true);
		buscarDependenciasSemLoading();
		setOpenCadastroUnidadeEmbarque(false);
	};

	const [openCadastroFilial, setOpenCadastroFilial] = useState(false);

	const [loadingSelectFilial, setLoadingSelectFilial] = useState(false);

	const handleCloseCadastroFilial = (value) => {
		setLoadingSelectFilial(true);
		buscarDependenciasSemLoading();
		setOpenCadastroFilial(false);
	};

	const [openCadastroEmpresa, setOpenCadastroEmpresa] = useState(false);

	const [loadingSelectEmpresa, setLoadingSelectEmpresa] = useState(false);

	const handleCloseCadastroEmpresa = (value) => {
		setLoadingSelectEmpresa(true);
		buscarDependenciasSemLoading();
		setOpenCadastroEmpresa(false);
	};

	const [openCadastroVeiculo, setOpenCadastroVeiculo] = useState(false);

	const [loadingSelectVeiculo, setLoadingSelectVeiculo] = useState(false);

	const handleCloseCadastroVeiculo = (value) => {
		setLoading(true);
		setLoadingSelectVeiculo(true);
		buscarDependenciasSemLoading();
		setOpenCadastroVeiculo(false);
	};

	const [openCadastroMercadoria, setOpenCadastroMercadoria] = useState(false);

	const [loadingSelectMercadoria, setLoadingSelectMercadoria] = useState(false);

	const handleCloseCadastroMercadoria = (value) => {
		setLoadingSelectMercadoria(true);
		buscarDependenciasSemLoading();
		setOpenCadastroMercadoria(false);
	};

	const [openCadastroEmbalagem, setOpenCadastroEmbalagem] = useState(false);

	const [loadingSelectEmbalagem, setLoadingSelectEmbalagem] = useState(false);

	const handleCloseCadastroEmbalagem = (value) => {
		setLoadingSelectEmbalagem(true);
		buscarDependenciasSemLoading();
		setOpenCadastroEmbalagem(false);
	};

	const [openCadastroStatus, setOpenCadastroStatus] = useState(false);

	const [loadingSelectStatus, setLoadingSelectStatus] = useState(false);

	const handleCloseCadastroStatus = (value) => {
		setLoadingSelectStatus(true);
		buscarDependenciasSemLoading();
		setOpenCadastroStatus(false);
	};

	const [openCadastroMotivo, setOpenCadastroMotivo] = useState(false);

	const [loadingSelectMotivo, setLoadingSelectMotivo] = useState(false);

	const handleCloseCadastroMotivo = (value) => {
		setLoadingSelectMotivo(true);
		buscarDependenciasSemLoading();
		setOpenCadastroMotivo(false);
	};

	const [openCadastroMeioPagamento, setOpenCadastroMeioPagamento] =
		useState(false);

	const [loadingSelectMeioPagamento, setLoadingSelectMeioPagamento] =
		useState(false);

	const handleCloseCadastroMeioPagamento = (value) => {
		setLoadingSelectMeioPagamento(true);
		buscarDependenciasSemLoading();
		setOpenCadastroMeioPagamento(false);
	};

	const [openConfirmar, setOpenConfirmar] = useState(false);

	const handleCloseConfirmar = (value) => {
		setOpenConfirmar(false);
	};

	const [openModalInformacoes, setOpenModalInformacoes] = useState(false);

	const handleCloseModalInformacoes = (value) => {
		setOpenModalInformacoes(false);
	};
	const [statusSMP, setStatusSMP] = useState(null);

	const [mensagensErro, setMensagensErro] = useState([]);
	const [mensagensAviso, setMensagensAviso] = useState([]);
	const [mensagensSucesso, setMensagensSucesso] = useState([]);

	const [openListaErro, setOpenListaErro] = useState(false);

	const handleCloseListaErro = (value) => {
		setOpenListaErro(false);
		handleSearch();
	};

	const handleCloseHistoricoEdicao = (value) => {
		setOpenHistoricoEdicao(false);
	};

	const [todos, setTodos] = useState(false);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const [openHistoricoStatus, setOpenHistoricoStatus] = useState(false);

	const handleCloseHistoricoStatus = (value) => {
		setOpenHistoricoStatus(false);
	};

	const abrirModalHistoricoStatus = () => {
		buscarStatusEmbarquePorId();
	};

	const [openHistoricoPedido, setOpenHistoricoPedido] = useState(false);

	const handleCloseHistoricoPedido = (value) => {
		setOpenHistoricoPedido(false);
	};

	const abrirModalHistoricoPedido = () => {
		buscarPedidoEmbarquePorId();
	};

	const [openHistoricoFreteFiscal, setOpenHistoricoFreteFiscal] =
		useState(false);

	const handleCloseHistoricoFreteFiscal = (value) => {
		setOpenHistoricoFreteFiscal(false);
	};

	const abrirModalHistoricoFreteFiscal = () => {
		buscarFreteFiscalEmbarquePorId();
	};

	const [openProposta, setOpenProposta] = useState(false);

	const handleCloseProposta = (value) => {
		setOpenProposta(false);
	};

	const [grupoCargaId, setGrupoCargaId] = useState();

	const [motoristasId, setMotoristasId] = useState([]);

	const [proprietariosId, setProprietariosId] = useState([]);

	const [listaGrupoCargas, setListaGrupoCarga] = useState([]);

	const [listaMotoristas, setListaMotorista] = useState([]);

	const [listaProprietarios, setListaProprietario] = useState([]);

	const buscarGrupoCargaVinculoDependencias = async () => {
		await getGrupoCargaDependencias(profile?.token)
			.then((result) => {
				setListaGrupoCarga(result.data.grupoCarga);
				setListaMotorista(result.data.motoristas);
				setListaProprietario(result.data.proprietarios);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const enviaProposta = async () => {
		let listaProposta = [];
		listaProposta.push({
			motoristasId: motoristasId,
			proprietariosId: proprietariosId,
			propostaId: null,
			embarqueId: tabelaRedux.colunaSelecionada,
			grupoCargaId: grupoCargaId,
		});
		await enviarProposta(listaProposta[0], profile?.token)
			.then((result) => {
				handleCloseProposta();
				setTabelaRedux({});
				setTextoSucesso("Cadastrado Com Sucesso");
				setOpenToastSucesso(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const tokenApi = localStorage.getItem("token");

	const calcular = (taxa) => {
		const taxaCalculada =
			((parseFloat(values.freteFiscal) - parseFloat(taxa)) /
				parseFloat(values.freteFiscal)) *
			100;
		const taxaFormatada = taxaCalculada.toFixed(2).toString();
		setValues((current) => ({ ...current, margem: taxaFormatada }));
	};

	const buscarDependencias = async () => {
		if (contextoEmbarque) {
			setLoading(true);
			await getEmbarqueDependencias(tokenApi, contextoEmbarque)
				.then((result) => {
					setListaUnidades(result.data.unidadeEmbarque);
					setListaEmpresas(result.data.empresaSub);
					setListaFilial(result.data.filial);
					setPedido(result.data.pedido);
					setListaVeiculos(result.data.veiculo);
					setListaEmbalagens(result.data.embalagem);
					setListaStatus(result.data.status);
					setListaMeioPagamento(result.data.meioPagamento);
					setListaMotivo(result.data.motivo);
					setListaMercadoria(result.data.mercadoria);
					setDadosTabela(result.data.embarque);
					setDadosTabelaCopia(result.data.embarque);
					setDadosTabelaCopiaFiltro(result.data.embarque);
					setTabelaRedux({});
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	const buscarTemplates = async () => {
		setLoading(true);
		await getTemplateEmbarque(tokenApi)
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarDependenciasDataInicial = async (data) => {
		if (contextoEmbarque !== "templateEmbarque") {
			setLoading(true);
			await getEmbarqueGeral(tokenApi, contextoEmbarque, data)
				.then((result) => {
					const listaEmbarques = [];
					result.data.embarques.forEach((embarque) => {
						if (embarque.cancelado === false) {
							listaEmbarques.push(embarque);
						}
					});
					setSomatorioFreteFiscal(result.data?.cards?.freteFiscalString);
					setSomatorioFreteMotorista(result?.data.cards?.freteMotoristaString);
					setSomatorioIcms(result.data?.cards?.icmsString);
					setSomatorioKm(result.data?.cards?.kmString);
					setNumeroEmbarques(listaEmbarques.length);
					setDadosTabela(result.data.embarques);
					setDadosTabelaCopia(result.data.embarques);
					setDadosTabelaCopiaFiltro(result.data.embarques);
					setTabelaRedux({});
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else if (contextoEmbarque === "templateEmbarque") {
			buscarTemplates();
		}
	};

	const buscarDependenciasData = async () => {
		if (contextoEmbarque !== "templateEmbarque") {
			setLoading(true);
			await getEmbarqueGeral(tokenApi, contextoEmbarque, dataPesquisa)
				.then((result) => {
					const listaEmbarques = [];
					result.data.embarques.forEach((embarque) => {
						if (embarque.cancelado === false) {
							listaEmbarques.push(embarque);
						}
					});
					setSomatorioFreteFiscal(result.data?.cards?.freteFiscalString);
					setSomatorioFreteMotorista(result.data?.cards?.freteMotoristaString);
					setSomatorioIcms(result.data?.cards?.icmsString);
					setSomatorioKm(result.data?.cards?.kmString);
					setEstadia(false);
					setFiltrosRedux((current) => ({
						...current,
						embarqueFinal: formatarData(result.data.fim),
					}));
					setFiltrosRedux((current) => ({
						...current,
						embarqueInicio: formatarData(result.data.inicio),
					}));
					setNumeroEmbarques(listaEmbarques.length);
					setDadosTabela(result.data.embarques);
					setDadosTabelaCopia(result.data.embarques);
					setTabelaRedux({});
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else if (contextoEmbarque === "templateEmbarque") {
			buscarTemplates();
		}
	};

	const buscarDependenciasSemLoading = async () => {
		const date = new Date();
		var ddFinal = String(date?.getDate()).padStart(2, "0");
		var mmFinal = String(date?.getMonth() + 1).padStart(2, "0");
		var yyyyFinal = date?.getFullYear();
		var dateFinalFormated = yyyyFinal + "-" + mmFinal + "-" + ddFinal;
		if (contextoEmbarque !== "templateEmbarque") {
			await getEmbarqueGeral(tokenApi, contextoEmbarque, dateFinalFormated)
				.then((result) => {
					setDadosTabela(result.data.embarques);
					setDadosTabelaCopia(result.data.embarques);
					setSomatorioFreteFiscal(result.data?.cards?.freteFiscalString);
					setSomatorioFreteMotorista(result.data?.cards?.freteMotoristaString);
					setSomatorioIcms(result.data?.cards?.icmsString);
					setSomatorioKm(result.data?.cards?.kmString);
					setTabelaRedux({});
					setLoadingSelectPedido(false);
					setLoadingSelectUnidadeEmbarque(false);
					setLoadingSelectFilial(false);
					setLoadingSelectEmpresa(false);
					setLoadingSelectVeiculo(false);
					setLoadingSelectEmbalagem(false);
					setLoadingSelectStatus(false);
					setLoadingSelectMercadoria(false);
					setLoadingSelectMotivo(false);
					setLoadingSelectMeioPagamento(false);
					setLoading(false);
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
						setLoading(false);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
						setOpenToastErro(true);
						setLoading(false);
					}
					setLoadingSelectPedido(false);
					setLoadingSelectFilial(false);
					setLoadingSelectEmpresa(false);
					setLoadingSelectVeiculo(false);
					setLoadingSelectEmbalagem(false);
					setLoadingSelectStatus(false);
					setLoadingSelectUnidadeEmbarque(false);
					setLoadingSelectMercadoria(false);
					setLoadingSelectMotivo(false);
					setLoadingSelectMeioPagamento(false);
					setLoading(false);
				});
		} else if (contextoEmbarque === "templateEmbarque") {
			buscarTemplates();
		}
	};

	const buscarHistoricoEmbarque = async (codigo) => {
		if (codigo === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoEmbarque(codigo, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValoresHistorico(result.data);
						setOpenHistoricoEdicao(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarStatusEmbarquePorId = async (flag) => {
		await getEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoStatus(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarPedidoEmbarquePorId = async (flag) => {
		await getEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoPedido(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarFreteFiscalEmbarquePorId = async (flag) => {
		await getEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					buscarHistoricoFreteFiscal(result.data.embarqueHistoricoId);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarHistoricoStatus = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoStatus(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setOpcoesOpen(false);
						setValoresHistoricoStatus(result.data);
						setOpenHistoricoStatus(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarHistoricoPedido = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoPedido(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setOpcoesOpen(false);
						setValoresHistoricoPedido(result.data);
						setOpenHistoricoPedido(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarHistoricoFreteFiscal = async (id) => {
		if (id === null) {
			setTextoErro("Nada Encontrado!");
			setOpenToastErro(true);
		} else {
			await getHistoricoFreteFiscal(id, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setOpcoesOpen(false);
						setValoresHistoricoFreteFiscal(result.data);
						setOpenHistoricoFreteFiscal(true);
					}
				})
				.catch((error) => {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				});
		}
	};

	const buscarTemplatePorId = async (flag) => {
		if (editando) setLoading(true);
		await getTemplateEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);

						var todayEm = new Date(result.data.dataEmbarque);
						var ddEm = String(todayEm.getDate()).padStart(2, "0");
						var mmEm = String(todayEm.getMonth() + 1).padStart(2, "0");
						var yyyyEm = todayEm.getFullYear();
						todayEm = yyyyEm + "-" + mmEm + "-" + ddEm;
						setValues((current) => ({ ...current, dataEmbarque: todayEm }));

						var todayEn = new Date(result.data.dataEntrega);
						var ddEn = String(todayEn.getDate()).padStart(2, "0");
						var mmEn = String(todayEn.getMonth() + 1).padStart(2, "0");
						var yyyyEn = todayEn.getFullYear();
						todayEn = yyyyEn + "-" + mmEn + "-" + ddEn;
						setValues((current) => ({ ...current, dataEntrega: todayEn }));

						var todayPrEm = new Date(result.data.previsaoEmbarque);
						var ddPrEm = String(todayPrEm.getDate()).padStart(2, "0");
						var mmPrEm = String(todayPrEm.getMonth() + 1).padStart(2, "0");
						var yyyyPrEm = todayPrEm.getFullYear();
						todayPrEm = yyyyPrEm + "-" + mmPrEm + "-" + ddPrEm;
						setValues((current) => ({
							...current,
							previsaoEmbarque: todayPrEm,
						}));

						var todayPrEn = new Date(result.data.previsaoEntrega);
						var ddPrEn = String(todayPrEn.getDate()).padStart(2, "0");
						var mmPrEn = String(todayPrEn.getMonth() + 1).padStart(2, "0");
						var yyyyPrEn = todayPrEn.getFullYear();
						todayPrEn = yyyyPrEn + "-" + mmPrEn + "-" + ddPrEn;
						setValues((current) => ({
							...current,
							previsaoEntrega: todayPrEn,
						}));
						setLoading(false);
					} else if (flag) {
						buscarHistoricoEmbarque(result.data.embarqueHistoricoId);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	function formatarValores(resultData) {
		const colunasIgnorar = [
			"idEmbarque",
			"nEntregas",
			"nEntregasFeitas",
			"pedido",
			"km",
			"usuarioResponsavelId",
			"embarqueHistoricoId",
			"load",
			"cte",
			"peso",
		];
		const ehInteger = (value) => {
			return (
				(typeof value === "number" && Math.floor(value) === value) ||
				(typeof value === "string" && /^\d+$/.test(value))
			);
		};
		Object.keys(resultData).forEach((key) => {
			if (colunasIgnorar.includes(key)) {
				return;
			}
			const value = resultData[key];
			if (ehInteger(value)) {
				resultData[key] = `${value},00`;
			}
		});

		return resultData;
	}

	const [dadoContato, setDadoContato] = useState(null);

	const [dadoMotorista, setDadoMotorista] = useState(null);

	const buscarTipoContato = async (value) => {
		await getTipoContatoPorProprietarioId(value, profile?.token)
			.then((result) => {
				setDadoContato(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
	};

	const buscarEmbarquePorId = async (flag) => {
		if (editando) setLoading(true);
		await getEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						const formattedData = formatarValores(result.data);
						if (
							result.data.veiculo !== null &&
							result.data.veiculoMotorista !== null
						) {
							setDadoMotorista(result.data.veiculoMotorista);
							buscarTipoContato(
								result.data.veiculo.proprietarioVeiculo.idProprietario
							);
						} else {
							setLoading(false);
						}
						setValues(formattedData);
					} else if (flag) {
						buscarHistoricoEmbarque(result.data.embarqueHistoricoId);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarEmbarquePorIdRota = async (id) => {
		if (editando) setLoading(true);
		await getEmbarquePorId(id, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					const formattedData = formatarValores(result.data);
					setValues(formattedData);
					setEditando2(true);
					setTelaCadastro(true);
					setLoading(false);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarTemplatePorId = async () => {
		setLoading(true);
		await deleteTemplateEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
			.then((result) => {
				if (result.status === 200) {
					buscarTemplates();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const deletarEmbarquePorId = async () => {
		if (contextoEmbarque === "templateEmbarque") {
			deletarTemplatePorId();
		} else {
			setLoading(true);
			await deleteEmbarquePorId(tabelaRedux.colunaSelecionada, tokenApi)
				.then((result) => {
					if (result.status === 200) {
						if (contextoEmbarque === "todos") {
							setTodos(true);
						} else {
							setTodos(false);
							setValues((current) => ({
								...current,
								contexto: contextoEmbarque,
							}));
						}
						setTabelaRedux({});
						setOpenToastSucesso(true);
						setLoading(false);
						buscarSearch();
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		}
	};

	useEffect(() => {
		if (!editando) setValues((current) => ({ ...current, cancelado: false }));
		if (profile) {
			setValues((current) => ({
				...current,
				usuario: profile?.usuario.usuario,
			}));
		}
	}, [loading]);

	const [dadosFiltrados, setDadosFiltrados] = useState([]);

	const filtraPedido = () => {
		var dadosfiltra = pedido;
		dadosfiltra.sort(function (a, b) {
			if (a.pedido < b.pedido) {
				return -1;
			} else {
				return true;
			}
		});
		setDadosFiltrados(dadosfiltra);
	};

	const dadosOrdenados = dadosFiltrados;

	const [dadosFiltrados2, setDadosFiltrados2] = useState([]);

	const filtraVeiculo = () => {
		var dadosfiltra = listaVeiculos;
		dadosfiltra.sort(function (a, b) {
			if (a.placaCavalo < b.placaCavalo) {
				return -1;
			} else {
				return true;
			}
		});
		setDadosFiltrados2(dadosfiltra);
	};

	const dadosOrdenados2 = dadosFiltrados2;

	useEffect(() => {
		filtraPedido();
	}, [loadingSelectPedido]);

	useEffect(() => {
		if (!loading) {
			filtraPedido();
			filtraVeiculo();
		}
	}, [loading]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const [semAutorizacaoGerarLogin, setSemAutorizacaoGerarLogin] =
		useState(true);

	const [openEmbarque, setOpenEmbarque] = useState(false);

	const handleCloseEmbarque = (value) => {
		setOpenEmbarque(false);
	};

	useEffect(() => {
		if (values.dataEmbarque === "2000-01-01") {
			values.dataEmbarque = "";
		}
		if (values.dataEntrega === "2000-01-01") {
			values.dataEntrega = "";
		}
		if (values.previsaoEmbarque === "2000-01-01") {
			values.previsaoEmbarque = "";
		}
		if (values.previsaoEntrega === "2000-01-01") {
			values.previsaoEntrega = "";
		}
		if (
			values.dataHoraChegadaEmbarque === "2000-01-01T00:00:00" ||
			values.dataHoraChegadaEmbarque === "2000-01-01T00:00"
		) {
			values.dataHoraChegadaEmbarque = "";
		}
		if (
			values.dataHoraChegadaEntrega === "2000-01-01T00:00:00" ||
			values.dataHoraChegadaEntrega === "2000-01-01T00:00"
		) {
			values.dataHoraChegadaEntrega = "";
		}
		if (
			values.dataHoraEntregue === "2000-01-01T00:00:00" ||
			values.dataHoraEntregue === "2000-01-01T00:00"
		) {
			values.dataHoraEntregue = "";
		}
		if (
			values.dataHoraEmbarcado === "2000-01-01T00:00:00" ||
			values.dataHoraEmbarcado === "2000-01-01T00:00"
		) {
			values.dataHoraEmbarcado = "";
		}
	}, [contextoEmbarque]);

	useEffect(() => {
		if (selecioneOpen === true) {
			setTimeout(() => {
				setSelecioneOpen(false);
			}, 1000);
		}
	}, [selecioneOpen]);

	useEffect(() => {
		if (opcoesOpen === true) {
			setTimeout(() => {
				setOpcoesOpen(false);
			}, 100);
		}
	}, [tabelaRedux.colunaSelecionada]);

	const inserirSMP = async () => {
		setOpcoesOpen(false);
		await insereSMP(embarqueId, profile?.token)
			.then((result) => {
				setMensagensAviso(result.data.result.mensagensAviso);
				setMensagensErro(result.data.result.mensagensErro);
				setMensagensSucesso(result.data.result.mensagensSucesso);
				setOpenListaErro(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarSMP = async () => {
		await buscaSMP(embarqueIdSMP, profile?.token)
			.then((result) => {
				const lista = [];
				lista.push(result.data.smp);
				setStatusSMP(lista);
				setOpcoesOpen(false);
				setEmbarqueIdSMP(undefined);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	useEffect(() => {
		if (statusSMP !== null || statusSMP !== undefined) {
			setOpenModalInformacoes(true);
		}
	}, [statusSMP]);

	const definirCte = async () => {
		const embarqueCancelado = {
			cte: cte,
			embarqueId: embarqueId,
		};
		await lancarCte(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseCTE();
				setTextoSucesso("CTE Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirStatus = async () => {
		const embarqueCancelado = {
			statusId: status,
			embarqueId: embarqueId,
		};
		await lancarStatus(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseStatus();
				setTextoSucesso("Status Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirMeioPagameto = async () => {
		const embarqueCancelado = {
			embarqueId: embarqueId,
			meioPagamentoId: meioPagamento1,
			meioPagamento2Id: meioPagamento2,
		};
		await definirMeiosPagamentos(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseMeioPagamento();
				setMeioPagamento1(null);
				setMeioPagamento2(null);
				setTextoSucesso("Meios de Pagamento Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirVeiculo = async () => {
		const embarqueCancelado = {
			embarqueId: embarqueId,
			veiculoId: veiculo,
			motorista: motorista,
		};
		await lancarVeiculo(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseVeiculo();
				setMotorista(null);
				setVeiculo(null);
				setTextoSucesso("Veiculo Definido com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirMercadoria = async () => {
		const embarqueCancelado = {
			mercadoriaId: mercadoria,
			embarqueId: embarqueId,
		};
		await lancarMercadoria(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseMercadoria();
				setTextoSucesso("Mercadoria Definida com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirEmbalagem = async () => {
		const embarqueCancelado = {
			embalagemId: embalagem,
			embarqueId: embarqueId,
		};
		await lancarEmbalagem(embarqueCancelado, profile?.token)
			.then((result) => {
				handleCloseEmbalagem();
				setTextoSucesso("Embalagem Definida com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirComprovante = async () => {
		await comprovanteEntregue(embarqueId, profile?.token)
			.then((result) => {
				setTextoSucesso("Comprovante Informado com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const definirCheck = async () => {
		await lancarCheckin(embarqueId, profile?.token)
			.then((result) => {
				setTextoSucesso("Checkin Concluído com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const cancelarCarga = async () => {
		const embarqueCancelado = {
			motivoId: motivoId2,
			embarqueId: embarqueId,
		};
		await cancelarEmbarque(embarqueCancelado, profile?.token)
			.then((result) => {
				setOpenMotivoCancelado(false);
				setNomeMotivo(null);
				setMotivoId(null);
				setTextoSucesso("Carga Cancelada com Sucesso!");
				setOpenToastSucesso(true);
				handleSearch();
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const vincularMotivoOnTime = async () => {
		let bool = false;
		if (isEmbarque === true) {
			bool = true;
		}
		if (isEntrega === true) {
			bool = false;
		}
		await vincularMotivoPorId(profile?.token, embarqueId, motivoId, bool)
			.then((result) => {
				if (result.status === 200) {
					handleCloseMotivoOnTime();
					buscarMotivo();
					setNomeMotivo(null);
					setMotivoId(null);
					setTextoSucesso("Cadastrado com Sucesso!");
					setOpenToastSucesso(true);
					setEmbarqueId(null);
					handleSearch();
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const headers = [
		{ label: "ID", key: "idEmbarque" },
		{ label: "Empresa", key: "empresa" },
		{ label: "Filial", key: "filial" },
		{ label: "Unidade Embarque", key: "unidEmbarque" },
		{ label: "Cidade Origem", key: "cidadeOrigem" },
		{ label: "Estado Origem", key: "estadoOrigem" },
		{ label: "Cidade Destino", key: "cidadeDestino" },
		{ label: "Estado Destino", key: "estadoDestino" },
		{ label: "Pedido", key: "pedido" },
		{ label: "Previsão Viagem", key: "previsaoEmbarque" },
		{ label: "Data Viagem", key: "dataEmbarque" },
		{ label: "Previsão Entrega", key: "previsaoEntrega" },
		{ label: "Data Entrega", key: "dataEntrega" },
		{ label: "Aceite", key: "aceite" },
		{ label: "Status", key: "status" },
		{ label: "Placa Cavalo", key: "placaCavalo" },
		{ label: "Placa Carreta", key: "placaCarreta" },
		{ label: "Placa Carreta 2", key: "placaCarreta2" },
		{ label: "Proprietário", key: "proprietario" },
		{ label: "Motorista", key: "motorista" },
		{ label: "Frete Fiscal", key: "freteFiscal" },
		{ label: "ICMS", key: "icms" },
		{ label: "Frete Motorista", key: "freteMotorista" },
		{ label: "Adicional Empresa", key: "adicionalEmpresa" },
		{ label: "Adicional Motorista", key: "adicionalMotorista" },
		{ label: "Pedagio", key: "pedagio" },
		{ label: "Classificacao", key: "classificacao" },
		{ label: "Adiantamento", key: "adiantamento" },
		{ label: "Saldo", key: "saldo" },
		{ label: "Meio Pagamento", key: "meioPagamento" },
		{ label: "Meio Pagamento 2", key: "meioPagamento2" },
		{ label: "KM", key: "km" },
		{ label: "Cliente", key: "cliente" },
		{ label: "Embarcador", key: "embarcador" },
		{ label: "Destinatário", key: "destinatario" },
		{ label: "Load", key: "load" },
		{ label: "Mercadoria", key: "mercadoria" },
		{ label: "Peso", key: "peso" },
		{ label: "Embalagem", key: "embalagem" },
		{ label: "Observação", key: "observacao" },
		{ label: "Frota", key: "frota" },
		{ label: "Cancelado", key: "cancelado" },
		{ label: "Motivo", key: "motivo" },
	];

	let novaArray = [];

	if (!Array.isArray(dadosTabela)) {
		novaArray.push(dadosTabela);
	} else {
		novaArray = dadosTabela;
	}

	const chavesRemover = [
		"deletado",
		"embarqueHistoricoId",
		"contexto",
		"dataHoraChegadaEmbarque",
		"dataHoraEmbarcado",
		"dataHoraChegadaEntrega",
		"dataHoraEntregue",
		"data",
		"usuario",
	];
	const listaFiltradaObjetos = novaArray.map((obj) => {
		const novoObjeto = Object.keys(obj)
			.filter((key) => !chavesRemover.includes(key))
			.reduce((novoObjeto, key) => {
				novoObjeto[key] = obj[key];
				return novoObjeto;
			}, {});
		return novoObjeto;
	});

	const chavesFormatar = [
		"previsaoEmbarque",
		"dataEmbarque",
		"previsaoEntrega",
		"dataEntrega",
	];
	const listaFormatada = listaFiltradaObjetos.map((obj) => {
		const novoObj = {};
		Object.keys(obj).forEach((key) => {
			if (chavesFormatar.includes(key) && obj[key]) {
				novoObj[key] = obj[key].replace(/T00:00:00/, "");
			} else {
				novoObj[key] = obj[key];
			}
		});
		return novoObj;
	});

	const [odenConfig, setOpenConfig] = useState(false);

	const handleCloseConfig = (value) => {
		if (dadosRequestControllerRedux === "Sucesso") {
			setTextoSucesso("Alterado Com Sucesso");
			setOpenToastSucesso(true);
			setOpenConfig(false);
			handleSearch();
		}
		setOpenConfig(false);
		handleSearch();
	};

	const [openLegenda, setOpenLegenda] = useState(false);

	const handleCloseLegenda = (value) => {
		setOpenLegenda(false);
	};

	const location = useLocation();

	const getQueryParam = (param) => {
		return new URLSearchParams(location.search).get(param);
	};

	useEffect(() => {
		const id = getQueryParam("id");
		if (id && id !== undefined && id !== null && id !== "undefined") {
			buscarEmbarquePorIdRota(id);
		}
	}, [location]);

	const opcoesRota = dadosAgrupado.map((data, index) => ({
		value: data.nomeMesorregiao,
		label: data.nomeMesorregiao,
		label2: data.uf,
		id: index,
	}));

	const estiloRota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: "250px",
			zIndex: 1000,
		}),
		singleValue: (provided) => ({
			...provided,
		}),
		option: (provided) => ({
			...provided,
		}),
	};

	const labelRota = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.label} - {data.label2}
		</div>
	);

	useEffect(() => {
		buscarSearch();
	}, [canceladoRegiao]);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Mesorregião"));
		}
	}, [profile?.token]);

	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
			<>
				{!loading ? (
					<>
						{semAutorizacao ? (
							<>
								<NavbarV3
									selecionado={contextoEmbarque}
									setTelaCadastro={setTelaCadastro}
								/>
								<SemAutorizacao></SemAutorizacao>
								<ModalEmbarque
									open={openEmbarque}
									onClose={handleCloseEmbarque}
								/>
							</>
						) : (
							<div>
								<NavbarV3
									selecionado={contextoEmbarque}
									setTelaCadastro={setTelaCadastro}
								/>
								{!loading ? (
									<motion.div
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
									>
										{!telaCadastro ? (
											<div>
												{!todos ? (
													<div className="embarques">
														<div className="header-embarque-v2">
															<div className="flex">
																{contextoEmbarque !== "templateEmbarque" ? (
																	<p className="indicador-principal-embarque-v2">
																		Viagens - {mesoRegiao} - {ufMesoRegiao}
																	</p>
																) : (
																	<p className="indicador-principal-embarque-v2">
																		Modelo Viagens
																	</p>
																)}
																<Tooltip title={mesAtual}>
																	<img
																		onClick={() => setOpenLegenda(true)}
																		className="mes-atual"
																		src={iconeInfo}
																	/>
																</Tooltip>
																<div
																	style={{
																		display: "flex",
																		alignItems: "center",
																	}}
																>
																	<Separator direction="horizontal" size="md" />
																	<div
																		className="icon-div"
																		style={{
																			cursor: "pointer",
																		}}
																		onClick={setPrev}
																	>
																		<Icon
																			name="ChevronLeft"
																			size="xl"
																			theme="dark"
																		/>
																	</div>
																	<Separator direction="horizontal" size="md" />
																	<div
																		className="icon-div"
																		style={{
																			cursor: "pointer",
																		}}
																		onClick={setProx}
																	>
																		<Icon
																			name="ChevronRight"
																			size="xl"
																			theme="dark"
																		/>
																	</div>
																	<Separator direction="horizontal" size="md" />
																	<FormControlLabel
																		control={
																			<Checkbox
																				checked={canceladoRegiao}
																				onChange={(e) => {
																					if (e.target.checked === true) {
																						setCanceladoRegiao(true);
																					} else {
																						setCanceladoRegiao(false);
																					}
																				}}
																			/>
																		}
																		label={"Cancelado"}
																	/>
																	<FormControl sx={{ width: 250 }}>
																		<Select
																			value={values.embarcador}
																			options={opcoesRota}
																			formatOptionLabel={labelRota}
																			styles={estiloRota}
																			placeholder=""
																			noOptionsMessage={() =>
																				"Não há mais opções"
																			}
																			onChange={(selectedOption) => {
																				if (selectedOption) {
																					setIndex(selectedOption.id);

																					clearInterval(intervalRef.current);
																					setProx();
																					intervalRef.current = setInterval(
																						setProx,
																						30000
																					);
																				}
																			}}
																		/>
																	</FormControl>
																	<CustomButton
																		classCss="custom-button-meso"
																		titulo="Mapa"
																		cor="#0946B8"
																		onClick={() => {
																			voltar();
																		}}
																	/>
																</div>
															</div>
															<div className="flex">
																{contextoEmbarque !== "templateEmbarque" ? (
																	<>
																		<CSVLink
																			className="csv-botao"
																			data={listaFormatada}
																			headers={headers}
																			filename={`Viagens`}
																		>
																			<Tooltip
																				title={
																					<p>Baixar dados em formato .csv</p>
																				}
																			>
																				<IconButton className="butao-csv">
																					<img src={iconeDownload} />
																				</IconButton>
																			</Tooltip>
																		</CSVLink>
																	</>
																) : (
																	<></>
																)}
																<div className="filtro">
																	<Tooltip
																		title={<p>Abrir configurações colunas</p>}
																	>
																		<IconButton className="butao-csv">
																			<img
																				src={iconeConfig}
																				className="click-configurar"
																				onClick={() => setOpenConfig(true)}
																			/>
																		</IconButton>
																	</Tooltip>
																</div>
																<div className="fat-botoes-embarque-2">
																	<Tooltip title={<p>Exibir Somatório</p>}>
																		<BackupTableIcon
																			className="icon-calculate"
																			onClick={(e) => {
																				onClickOpenSomatorio();
																			}}
																		/>
																	</Tooltip>
																	<Tooltip title={<p>Alterar Tabela</p>}>
																		<CalculateIcon
																			className="icon-calculate"
																			onClick={(e) => {
																				onClickOpenProjecao();
																			}}
																		/>
																	</Tooltip>
																</div>
															</div>
														</div>
														<div className="filtro-embarque-v2">
															<FiltroV2
																classe="div-filtrar-embarque-v2"
																classOption="select-options"
																itensFiltro={itensFiltro}
																valuesPesquisa={valuesPesquisa}
																setValuesPesquisa={setValuesPesquisa}
																buscarSearch={buscarSearch}
																limpar={limpar}
																setCompleto={setCompleto}
																setPeriodoCompleto={setPeriodoCompleto}
																periodoCompleto={periodoCompleto}
																mesAnterior={mesAnterior}
																mesSeguinte={mesSeguinte}
																setEstadia={setEstadia}
																setFiltroEstadia={setFiltroEstadia}
																estadia={estadia}
															/>
															<div className="fat-botoes-embarque">
																{contextoEmbarque !== "templateEmbarque" ? (
																	<CustomButtonV2
																		classCss="custom-button-faturamento"
																		classText="button-texto-faturamento"
																		titulo={"Exibir Somatório"}
																		cor="#FFFFFF"
																		onClick={onClickOpenSomatorio}
																	/>
																) : (
																	<></>
																)}
																<CustomButtonV2
																	classCss="custom-button-faturamento"
																	classText="button-texto-faturamento"
																	titulo={"Alterar Tabela"}
																	cor="#FFFFFF"
																	onClick={onClickOpenProjecao}
																/>
															</div>
														</div>
														{cardSomatorio &&
															contextoEmbarque !== "templateEmbarque" && (
																<div>
																	<div className="container-embarque-card">
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Número de Viagens
																			</div>
																			<div className="card-body-embarque">
																				{numeroEmbarque}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Frete Fiscal
																			</div>
																			<div className="card-body-embarque">
																				{somatorioFreteFiscal}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Freta Motorista
																			</div>
																			<div className="card-body-embarque">
																				{somatorioFreteMotorista}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Icms
																			</div>
																			<div className="card-body-embarque">
																				{somatorioIcms}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório KM
																			</div>
																			<div className="card-body-embarque">
																				{somatorioKm}
																			</div>
																		</div>
																	</div>
																</div>
															)}
														{viewTable ? (
															contextoEmbarque !== "templateEmbarque" ? (
																<TabelaV2
																	setTelaCadastro={setTelaCadastro}
																	setEditando={setEditando}
																	classeSelecionado="idEmbarque"
																	nomeClasse1="outer-wrapper"
																	nomeClasse2={
																		cardSomatorio
																			? "table-wrapper-v2-low"
																			: "table-wrapper-v2"
																	}
																	colunas={dadosTabelaRedux.Embarque}
																	dados={dadosTabela}
																	nome="embarque"
																	nomeTable="Embarque"
																	numeroEmbarque={numeroEmbarque}
																	buscarOrdenacao={buscarOrdenacao}
																/>
															) : (
																<TabelaV2
																	setTelaCadastro={setTelaCadastro}
																	setEditando={setEditando}
																	classeSelecionado="idEmbarqueTemplete"
																	nomeClasse1="outer-wrapper"
																	nomeClasse2={
																		cardSomatorio
																			? "table-wrapper-v2-low"
																			: "table-wrapper-v2"
																	}
																	colunas={dadosTabelaRedux.ModeloEmbarque}
																	dados={dadosTabela}
																	nome="embarque"
																	nomeTable="ModeloEmbarque"
																	numeroEmbarque={numeroEmbarque}
																	buscarOrdenacao={buscarOrdenacao}
																/>
															)
														) : (
															<TabelaLow
																setTelaCadastro={setTelaCadastro}
																setEditando={setEditando}
																setTextoErro={setTextoErro}
																setOpenToastErro={setOpenToastErro}
																colunas={dadosTabelaRedux.Embarque}
																dados={dadosTabela}
																buscarEmbarquePorId={buscarEmbarquePorId}
																setOpenUsuario={setOpenUsuario}
																setOpen={setOpen}
																setTextoSucesso={setTextoSucesso}
																setOpcoesOpen={setOpcoesOpen}
																setSelecioneOpen={setSelecioneOpen}
																opcoesOpen={opcoesOpen}
																acoesData={acoesData}
																numeroEmbarque={numeroEmbarque}
															/>
														)}
													</div>
												) : (
													<div className="embarques">
														<div className="header-embarque-v2">
															<div className="flex">
																<p className="indicador-principal-embarque-v2">
																	Viagens - {mesoRegiao} - {ufMesoRegiao}
																</p>
																<Tooltip title={mesAtual}>
																	<img
																		onClick={() => setOpenLegenda(true)}
																		className="mes-atual"
																		src={iconeInfo}
																	/>
																</Tooltip>
															</div>
															<div className="flex">
																{contextoEmbarque !== "templateEmbarque" ? (
																	<>
																		<CSVLink
																			className="csv-botao"
																			data={listaFormatada}
																			headers={headers}
																			filename={`Viagens`}
																		>
																			<Tooltip
																				title={
																					<p>Baixar dados em formato .csv</p>
																				}
																			>
																				<IconButton className="butao-csv">
																					<img src={iconeDownload} />
																				</IconButton>
																			</Tooltip>
																		</CSVLink>
																	</>
																) : (
																	<></>
																)}
																<div className="filtro">
																	<Tooltip
																		title={<p>Abrir configurações colunas</p>}
																	>
																		<IconButton className="butao-csv">
																			<img
																				src={iconeConfig}
																				className="click-configurar"
																				onClick={() => setOpenConfig(true)}
																			/>
																		</IconButton>
																	</Tooltip>
																</div>
															</div>
														</div>
														<div className="filtro-embarque-v2">
															<FiltroV2
																classe="div-filtrar-embarque-v2"
																classOption="select-options"
																itensFiltro={itensFiltro}
																valuesPesquisa={valuesPesquisa}
																setValuesPesquisa={setValuesPesquisa}
																buscarSearch={buscarSearch}
																limpar={limpar}
																setCompleto={setCompleto}
																setPeriodoCompleto={setPeriodoCompleto}
																periodoCompleto={periodoCompleto}
																mesAnterior={mesAnterior}
																mesSeguinte={mesSeguinte}
															/>
															<div className="fat-botoes-embarque">
																{contextoEmbarque !== "templateEmbarque" ? (
																	<CustomButtonV2
																		classCss="custom-button-faturamento"
																		classText="button-texto-faturamento"
																		titulo={"Exibir Somatório"}
																		cor="#FFFFFF"
																		onClick={onClickOpenSomatorio}
																	/>
																) : (
																	<></>
																)}
																<CustomButtonV2
																	classCss="custom-button-faturamento"
																	classText="button-texto-faturamento"
																	titulo={"Alterar Tabela"}
																	cor="#FFFFFF"
																	onClick={onClickOpenProjecao}
																/>
															</div>
														</div>
														{cardSomatorio &&
															contextoEmbarque !== "templateEmbarque" && (
																<div>
																	<div className="container-embarque-card">
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Número de Viagens
																			</div>
																			<div className="card-body-embarque">
																				{numeroEmbarque}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Frete Fiscal
																			</div>
																			<div className="card-body-embarque">
																				{somatorioFreteFiscal}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Freta Motorista
																			</div>
																			<div className="card-body-embarque">
																				{somatorioFreteMotorista}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório Icms
																			</div>
																			<div className="card-body-embarque">
																				{somatorioIcms}
																			</div>
																		</div>
																		<div className="card-embarque">
																			<div className="card-header-embarque">
																				Somatório KM
																			</div>
																			<div className="card-body-embarque">
																				{somatorioKm}
																			</div>
																		</div>
																	</div>
																</div>
															)}
														{viewTable ? (
															contextoEmbarque !== "templateEmbarque" ? (
																<TabelaV2
																	setTelaCadastro={setTelaCadastro}
																	setEditando={setEditando}
																	classeSelecionado="idEmbarque"
																	nomeClasse1="outer-wrapper"
																	nomeClasse2={
																		cardSomatorio
																			? "table-wrapper-v2-low"
																			: "table-wrapper-v2"
																	}
																	colunas={dadosTabelaRedux.Embarque}
																	dados={dadosTabela}
																	nome="embarque"
																	nomeTable="Embarque"
																	numeroEmbarque={numeroEmbarque}
																	buscarOrdenacao={buscarOrdenacao}
																/>
															) : (
																<TabelaV2
																	setTelaCadastro={setTelaCadastro}
																	setEditando={setEditando}
																	classeSelecionado="idEmbarqueTemplete"
																	nomeClasse1="outer-wrapper"
																	nomeClasse2={
																		cardSomatorio
																			? "table-wrapper-v2-low"
																			: "table-wrapper-v2"
																	}
																	colunas={dadosTabelaRedux.ModeloEmbarque}
																	dados={dadosTabela}
																	nome="embarque"
																	nomeTable="ModeloEmbarque"
																	numeroEmbarque={numeroEmbarque}
																	buscarOrdenacao={buscarOrdenacao}
																/>
															)
														) : (
															<TabelaLow
																setTelaCadastro={setTelaCadastro}
																setEditando={setEditando}
																setTextoErro={setTextoErro}
																setOpenToastErro={setOpenToastErro}
																colunas={dadosTabelaRedux.Embarque}
																dados={dadosTabela}
																buscarEmbarquePorId={buscarEmbarquePorId}
																setOpenUsuario={setOpenUsuario}
																setTextoSucesso={setTextoSucesso}
																setOpcoesOpen={setOpcoesOpen}
																setSelecioneOpen={setSelecioneOpen}
																opcoesOpen={opcoesOpen}
																acoesData={acoesData}
																loading={loading}
																numeroEmbarque={numeroEmbarque}
															/>
														)}
														{viewTable ? (
															<div className="container-botoes-emb">
																<div>
																	<CustomButtonV2
																		classCss="custom-button-user"
																		classText="button-texto-user"
																		titulo="Obter Usuário"
																		cor="#FFFFFF"
																		valor={values}
																		onClick={() => {
																			if (tabelaRedux.usuarioAlteracao) {
																				setOpenUsuario(true);
																			} else {
																				setTextoErro("Selecione Uma Coluna");
																				setOpenToastErro(true);
																			}
																		}}
																	/>
																	{contextoEmbarque !== "templateEmbarque" ? (
																		<CustomButtonV2
																			classCss="custom-button-historico"
																			classText="button-texto-user"
																			titulo="Histórico"
																			cor="#FFFFFF"
																			valor={values}
																			onClick={() => {
																				if (tabelaRedux.colunaSelecionada) {
																					buscarEmbarquePorId(true);
																				} else {
																					setTextoErro("Selecione Uma Coluna");
																					setOpenToastErro(true);
																				}
																			}}
																		/>
																	) : (
																		<span></span>
																	)}
																</div>
															</div>
														) : (
															<></>
														)}
													</div>
												)}
											</div>
										) : (
											<div style={{ height: "170vh" }}>
												<div className="indicadores">
													{contextoEmbarque !== "templateEmbarque" ? (
														<>
															<p className="indicador-emb">
																{"Dados de Viagens / "}
															</p>
															<p className="indicador-emb">
																Cadastro de Viagens
															</p>
														</>
													) : (
														<>
															<p className="indicador-emb">
																{"Dados do Modelo / "}
															</p>
															<p className="indicador-emb">
																Cadastro de Modelo de Viagens
															</p>
														</>
													)}
												</div>
												<div className="flex">
													<div className="flex-emb">
														<HeaderCadastro
															texto={
																`Cadastro de Viagens - ${mesoRegiao}` -
																{ ufMesoRegiao }
															}
														/>
														<CloseIcon
															onClick={() => {
																setValues({});
																setDadoContato(null);
																setDadoMotorista(null);
																setDadosRequestControllerRedux(
																	"Cadastro False"
																);
																setEditando(false);
																setTabelaRedux({});
															}}
														/>
													</div>
												</div>
												{editando2 ? (
													<CadastroViagem
														dadoMotorista={dadoMotorista}
														dadoContato={dadoContato}
														dados={values}
														editando={editando}
													/>
												) : editando ? (
													<CadastroViagem
														dadoMotorista={dadoMotorista}
														dadoContato={dadoContato}
														dados={values}
														editando={editando}
													/>
												) : (
													<CadastroViagem
														dadoMotorista={dadoMotorista}
														dadoContato={dadoContato}
														editando={editando}
													/>
												)}
											</div>
										)}
										<div>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroPedido="sim"
												open={openCadastroPedido}
												onClose={handleCloseCadastroPedido}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroUnidadeEmbarque="sim"
												open={openCadastroUnidadeEmbarque}
												onClose={handleCloseCadastroUnidadeEmbarque}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroFilial="sim"
												open={openCadastroFilial}
												onClose={handleCloseCadastroFilial}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroEmpresaSub="sim"
												open={openCadastroEmpresa}
												onClose={handleCloseCadastroEmpresa}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroVeiculo="sim"
												open={openCadastroVeiculo}
												onClose={handleCloseCadastroVeiculo}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroMercadoria="sim"
												open={openCadastroMercadoria}
												onClose={handleCloseCadastroMercadoria}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroEmbalagem="sim"
												open={openCadastroEmbalagem}
												onClose={handleCloseCadastroEmbalagem}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroStatus="sim"
												open={openCadastroStatus}
												onClose={handleCloseCadastroStatus}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroMotivo="sim"
												open={openCadastroMotivo}
												onClose={handleCloseCadastroMotivo}
											/>
											<ModalCadastro
												titulo="Cadastro"
												tituloConfirmar="OK"
												cadastroMeioPagamento="sim"
												open={openCadastroMeioPagamento}
												onClose={handleCloseCadastroMeioPagamento}
											/>
											<ModalConfirmacao
												titulo="Deletar"
												texto="Deseja Deletar?"
												tituloConfirmar="Confirmar"
												tituloCancelar="Cancelar"
												open={open}
												onClose={handleClose}
												onClick={deletarEmbarquePorId}
											/>
											<ModalConfirmacao2
												titulo="SMP"
												texto="Deseja Inserir SMP?"
												tituloConfirmar="Sim"
												tituloCancelar="Não"
												textoBotao="Sim"
												open={openConfirmar}
												onClose={handleCloseConfirmar}
												onClick={inserirSMP}
											/>
											<ModalStatusSMP
												titulo="Status do SMP"
												textoBotao="OK"
												onClose={handleCloseModalInformacoes}
												onClick={handleCloseModalInformacoes}
												open={openModalInformacoes}
												statusSMP={statusSMP}
											/>
											<ModalListaErros
												titulo="Listagem Sucessos/Aviso/Erros"
												texto="Foram retornadas as seguintes ocorrências na tentaviva de inserir o SMP."
												tituloConfirmar="Sim"
												tituloCancelar="Não"
												textoBotao="Ok"
												open={openListaErro}
												onClose={handleCloseListaErro}
												onClick={handleCloseListaErro}
												mensagensAviso={mensagensAviso}
												mensagensErro={mensagensErro}
												mensagensSucesso={mensagensSucesso}
											/>
											<ModalUsuario
												titulo="Usuário"
												tituloConfirmar="OK"
												open={openUsuario}
												onClose={handleCloseUsuario}
											/>
											<ModalLegenda
												titulo="Legendas"
												tituloConfirmar="OK"
												open={openLegenda}
												onClose={handleCloseLegenda}
											/>
											<ModalHistoricoStatus
												titulo="Histórico Status"
												tituloConfirmar="OK"
												open={openHistoricoStatus}
												onClose={handleCloseHistoricoStatus}
												valoresHistorico={valoresHistoricoStatus}
												colunas={colunasStatusEmbarque}
											/>
											<ModalHistoricoStatus
												titulo="Histórico Pedido"
												tituloConfirmar="OK"
												open={openHistoricoPedido}
												onClose={handleCloseHistoricoPedido}
												valoresHistorico={valoresHistoricoPedido}
												colunas={colunasPedidoEmbarque}
											/>
											<ModalHistoricoStatus
												titulo="Histórico Frete Fiscal"
												tituloConfirmar="OK"
												open={openHistoricoFreteFiscal}
												onClose={handleCloseHistoricoFreteFiscal}
												valoresHistorico={valoresHistoricoFreteFiscal}
												colunas={colunasFreteFiscalEmbarque}
											/>
											<ModalHistoricoEdicao
												valueTabela={tabelaRedux}
												valueDados={valoresHistorico}
												valueUnico={values}
												open={openHistoricoEdicao}
												onClose={handleCloseHistoricoEdicao}
												titulo="Histórico"
												classeSelecionado="idEmbarque"
												colunas="Embarque"
												nome="embarque"
												nomeTable="Embarque"
											/>
											<ModalProposta
												titulo="Envio de Proposta"
												tituloConfirmar="Confirmar"
												tituloCancelar="Cancelar"
												open={openProposta}
												onClose={handleCloseProposta}
												onClick={enviaProposta}
												listaMotoristas={listaMotoristas}
												listaProprietarios={listaProprietarios}
												listaGrupoCargas={listaGrupoCargas}
												setGrupoCargaId={setGrupoCargaId}
												setMotoristasId={setMotoristasId}
												setProprietariosId={setProprietariosId}
											/>
											<ModalOnTime
												titulo="Vincular Motivo"
												tituloConfirmar="Confirmar"
												tituloCancelar="Cancelar"
												open={openMotivoOnTime}
												onClose={handleCloseMotivoOnTime}
												onClick={vincularMotivoOnTime}
												listaMotivos={listaMotivosOnTime}
												setMotivoId={setMotivoId}
												setNomeMotivo={setNomeMotivo}
											/>
											<ModalOnTime
												titulo="Motivo Cancelamento"
												tituloConfirmar="Confirmar"
												tituloCancelar="Cancelar"
												open={openMotivoCancelado}
												onClose={handleCloseMotivoCancelado}
												onClick={cancelarCarga}
												listaMotivos={listaMotivos}
												setMotivoId={setMotivoId2}
												setNomeMotivo={setNomeMotivo}
											/>
											<ModalLancarCTE
												titulo="Lançar CTE"
												tituloConfirmar="OK"
												open={openCTE}
												onClick={definirCte}
												onClose={handleCloseCTE}
												setCTE={setCTE}
											/>
											<ModalLancarStatus
												titulo="Lançar Status"
												tituloConfirmar="OK"
												open={openStatus}
												onClick={definirStatus}
												onClose={handleCloseStatus}
												setStatus={setStatus}
												listaStatus={listaStatus}
											/>
											<ModalLancarEmbalagem
												titulo="Lançar Embalagem"
												tituloConfirmar="OK"
												open={openEmbalagem}
												onClick={definirEmbalagem}
												onClose={handleCloseEmbalagem}
												setEmbalagem={setEmbalagem}
												listaEmbalagens={listaEmbalagens}
											/>
											<ModalLancarMercadoria
												titulo="Lançar Mercadoria"
												tituloConfirmar="OK"
												open={openMercadoria}
												onClick={definirMercadoria}
												onClose={handleCloseMercadoria}
												setMercadoria={setMercadoria}
												listaMercadoria={listaMercadoria}
											/>
											<ModalLancarVeiculo
												titulo="Lançar Veículo"
												tituloConfirmar="OK"
												open={openVeiculo}
												onClick={definirVeiculo}
												onClose={handleCloseVeiculo}
												setVeiculo={setVeiculo}
												setMotorista={setMotorista}
												listaVeiculos={listaVeiculos}
											/>
											<ModalLancarMeioPagamento
												titulo="Definir Meios de Pagameto"
												tituloConfirmar="OK"
												open={openMeioPagamento}
												onClick={definirMeioPagameto}
												onClose={handleCloseMeioPagamento}
												setMeioPagamento1={setMeioPagamento1}
												setMeioPagamento2={setMeioPagamento2}
												listaMeioPagamento={listaMeioPagamento}
											/>
											{contextoEmbarque !== "templateEmbarque" ? (
												<ModalConfigTabela
													titulo="Colunas Visíveis"
													tituloConfirmar="OK"
													open={odenConfig}
													onClose={handleCloseConfig}
													checks={dadosTabelaRedux.Embarque}
													nome={"embarque"}
												/>
											) : (
												<ModalConfigTabela
													titulo="Colunas Visíveis"
													tituloConfirmar="OK"
													open={odenConfig}
													onClose={handleCloseConfig}
													checks={dadosTabelaRedux.ModeloEmbarque}
													nome={"modelo"}
												/>
											)}
										</div>
										<div>
											<ToastSucesso
												texto={textoSucesso}
												open={openToastSucesso}
												onClose={handleCloseToastSucesso}
											/>
											<ToastErro
												texto={textoErro}
												open={openToastErro}
												onClose={handleCloseToastErro}
											/>
											<ToastAviso
												texto={textoAviso}
												open={openToastAviso}
												onClose={handleCloseToastAviso}
											/>
										</div>
									</motion.div>
								) : (
									<LoadingComponent />
								)}
							</div>
						)}
					</>
				) : (
					<>
						<NavbarV3 selecionado={contextoEmbarque} />
						<LoadingComponent />
					</>
				)}
			</>
		</motion.div>
	);
}
export default EmbarqueMesoRegiao;
